const attribute = ({ count = 0, isIncluded = false, name = '', percent = 0 }) => ({
  count: Number(count),
  isIncluded: Boolean(isIncluded),
  name: String(name),
  percent: Number(percent),
});

const PopularAttributes = ({ excluded = [], included = [], common = [] }) => ({
  excluded: excluded.map(attribute),
  included: included.map(attribute),
  common: [...common],
});

export default PopularAttributes;

export type PopularAttributesProps = ReturnType<typeof PopularAttributes>;
